<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <SharePriceBar/>
    <PageHeaderModal link-href="/" bgTint>
      <TextHeading variant="subtitle" color="secondary">Presentations</TextHeading>
      <TextHeading variant="lg" block>Interim Results Announcement 2018/19</TextHeading>
    </PageHeaderModal>
    <PageGrid modal>
      <PageMain>
        <iframe
          src="https://webcast.treetop.tv/dev/morrisons/index.html"
          width="100%"
          height="700px"
        />
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import PageMain from '../elements/PageMain.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeaderModal from '../components/PageHeaderModal.vue'
import SharePriceBar from '../components/SharePriceBar.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'PresentationsVideoLive',
  components: {
    TheHeader,
    BreadcrumbBar,
    SharePriceBar,
    PageHeaderModal,
    TextHeading,
    PageGrid,
    PageMain,
    TheFooter
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script><style lang="postcss">
.video__image-ratio {
  @apply aspect-ratio-16/9 w-full bg-body-dark relative overflow-hidden;
}
.video__image-ratio > img {
  @apply block absolute inset-y-0 inset-x-0 w-full h-full;
  object-fit: cover;
}
.video__details {
  @apply hidden;
}
@screen md {
  .video__details {
    @apply block shadow-md;
  }
}
</style>